import { IControl } from "../controltype/icontrol";
import { IValue } from '../conditionvalue/ivalue';

/**
 * 字段配置
 */
export class FieldConfig {

    /**
     * 字段ID
     */
    id?: string;

    /**
     * 字段标签，字段编号的唯一标识
     */
    labelCode: string;

    /**
     * 字段编号
     */
    code?: string;

    /**
     * 字段名称
     */
    name?: string;

    /**
     * 控件类型，目前包括文本类型，下拉列表，日期区间，数字区间，帮助类型
     * 控件类型为IControl接口，根据不同的控件类型对应不同的实现类，具体如下：
     * 1. 文本类型：TextControl
     * 2. 下拉列表：DropDownListControl
     * 3. 日期区间：DateRangeControl
     * 4. 数字区间：NumberRangeControl
     * 5. 帮助类型：SmartHelpContol
     */
    control?: IControl;

    /** 表单数据 */
    value?: any;

    // 默认显示
    placeHolder?: string;
    beginPlaceHolder?: string;
    endPlaceHolder?: string;
    /** 是否可见 */
    visible?: boolean;
}
